import { createFileRoute } from '@tanstack/react-router';
import Contacts from '../../../features/baseData/contacts/contacts';
import {
  CONTACTS_PERMISSIONS,
  createPermissionGuard,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute('/stammdaten/kontakte/')({
  component: Contacts,
  beforeLoad: createPermissionGuard(
    getPermissionSet(CONTACTS_PERMISSIONS, 'READ'),
  ),
});

export const ListContactRoute = Route;
